module.exports = function(dispatcher) {
  return function() {
    dispatcher.dispatch({
      type: 'imageLoaded'
    });
  };
};